import { useRef } from "react";
import { useInputEditor } from "src/components/useInputEditor";
import { useTinyMce } from "src/components/useTinyMce";
import styles from "./styles.module.scss";
import cx from "classnames";

type RenderType = "inputPlaceholder" | "buttonText";

interface NDACustomization {
  headerText: string;
  descriptionText: string;
  buttonText: string;
  inputPlaceholderText: string;
}

// parent renders (header, description, button, inputPlaceholder) 
export const useNDACustomization = ({ headerText, descriptionText, buttonText, inputPlaceholderText}: NDACustomization) => {
  const header = useNDACustomizationTinyMce({value: headerText}); // tinymce
  const description = useNDACustomizationTinyMce({value: descriptionText}); // tinymce
  const button = useNDACustomizationInput({ // inputEditor
    value: buttonText,
    viewerType: "buttonText",
  });
  const inputPlaceholder = useNDACustomizationInput({ // inputEditor
    value: inputPlaceholderText,
    viewerType: "inputPlaceholder",
  });

  return {
    header,
    description,
    button,
    inputPlaceholder,
  };
};

// inputEditor Hook
export function useNDACustomizationInput({value, viewerType}: {value: string, viewerType: RenderType}) {
   const values = useRef(value)
   return useInputEditor(values.current, viewerType);
}
// tinyMce Hook
export function useNDACustomizationTinyMce({value}: {value: string}) {
   const values = useRef(value)
   return useTinyMce(values.current);
}

// Viewer
export const NDACustomizationViewer = ({ HeaderText, Description ,ButtonText, InputPlaceHolderText, buttonColor, buttonTextColor }) => (
  <div className={styles.viewerContainer}>
    <div className={styles.innerContainer}>
      <p className={styles.header}>
                  Please enter your email here
      </p>
      <div className={styles.subContainer}>
         <InputPlaceHolderText />
          <div className={styles.header}>
          <HeaderText/>
         </div>
        <div className={styles.description}>
            <Description />
        </div>
        <p>
          <i className="paperflite-radio-button-unselected"></i> I have reviewed and agreed to the terms
        </p>
      </div>
    </div>
    <ButtonText inlineStyles={{ backgroundColor: buttonColor, color: buttonTextColor }} />
 </div>
);

// Editor
export const NDACustomizationEditor = ({  HeaderText, Description , ButtonText, InputPlaceHolderText }) => (
  <div className={styles.editorContainer}>
    <div className={styles.header}>
       <h5 className={styles.title}>NDA Customization</h5>
       <p className={styles.subText}>Customise the look and feel of the NDA screen that's shown before the audience starts looking at the content.</p>
    </div>
    <div className={styles.inputContainer}>
      <p className={styles.label}>Header Text</p>
      <HeaderText 
        classnames={cx(styles.tinyMce, styles.headerContainer)} 
        plugins = 'code noneditable, variable, widget,  autolink, link, textcolor, lists, paste'
        toolbar = 'bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor | link'
        quickToolbar={true}
        transparentBackground={true}
      />
    </div>
    <div className={styles.inputContainer}>
      <p className={styles.label}>Description Text</p>
      <Description
         classnames={cx(styles.tinyMce, styles.descriptionContainer)}
         plugins = 'code noneditable, variable, widget,  autolink, link, textcolor, lists, paste'
        toolbar = 'bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor | link'
        quickToolbar={true}
        transparentBackground={true}
      />
    </div>
    <div className={styles.inputGroup}>
      <div className={styles.inputContainer}>
         <p className={styles.label}>Button Text</p>
         <ButtonText maxLength={20}  />
      </div>
       <div className={styles.inputContainer}>
         <p className={styles.label}>Placeholder Text</p>
         <InputPlaceHolderText maxLength={20}  />
      </div>
    </div>
 </div>
);
